import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import {
  type CreateRequirementMappingDto,
  createRequirementMappingSchema,
  type RequirementMapping,
  requirementMappingResponseSchema,
} from "../types";

export function useCreateRequirementMapping(
  options?: UseMutationOptions<RequirementMapping, string, CreateRequirementMappingDto>
) {
  return useMutation(async (payload: CreateRequirementMappingDto) => {
    const response = await post({
      url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/requirement-mappings`,
      data: payload,
      requestSchema: createRequirementMappingSchema,
      responseSchema: requirementMappingResponseSchema,
    });

    return response.data.data;
  }, options);
}
